<!-- Alineaciones Campbell-->
<template>
  <div class="mt-2">
    <v-card elevation="5">
      <v-toolbar color="primaryLight" dark dense>
        <v-toolbar-title>Alineaciones Campbell</v-toolbar-title>
        <v-spacer />
        <v-tooltip bottom>
          <template #activator="{ on, attrs }">
            <v-btn fab small v-bind="attrs" v-on="on" color="secondary" bottom right class="me-3" :disabled="editAlineaciones" @click="showDialogAlineacionesCampBell ? hideAlineacionesCampbell() : showAlineacionesCampbell()">
              <v-icon color="primary">{{ showDialogAlineacionesCampBell ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon>
            </v-btn>
          </template>
          <span>{{ showDialogAlineacionesCampBell ? 'Ocultar' : 'Visualizar' }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template #activator="{ on, attrs }">
            <v-btn fab small v-bind="attrs" v-on="on" color="secondary" bottom right class="me-3" @click="initAlineacionesCampbell" :disabled="disabledByRol">
              <v-icon color="primary">mdi-shape-polygon-plus</v-icon>
            </v-btn>
          </template>
          <span>Alineaciones de Campbell</span>
        </v-tooltip>
      </v-toolbar>
    </v-card>
  </div>
</template>
<script>

import * as ArcGIS from '../../../helpers/ArcGIS'

export default {

  components: {},

  props: {
    idIncendio: String
  },

  data: () => ({

    graphicList: [],
    editAlineaciones: false,
    showDialogAlineacionesCampBell: false
  }),

  computed: {
    incendio () {
      return this.$store.getters['incendio/getIncendioByID'](this.idIncendio)
    },
    disabledByRol () {
      // Deshabilita funciones dependiendo del rol
      return !this.$store.getters['usuario/isCurrentUsuarioAdmin']
    }
  },

  methods: {
    initAlineacionesCampbell () {
      if (this.incendio && this.incendio.ALINEACIONES_CAMPBELL) {
        this.graphicList = this.incendio?.ALINEACIONES_CAMPBELL?.GRAFICOS_CAMPBELL || []
      } else {
        this.graphicList = []
      }
      this.editAlineaciones = true

      this.$eventHub.$emit('showAlineacionesCampbell', {
        callback: this.onDrawGraphicsEnded,
        graphics: JSON.parse(JSON.stringify(this.graphicList)) // Clonar lista
      })
    },
    showAlineacionesCampbell () {
      this.showDialogAlineacionesCampBell = true
      if (this.incendio && this.incendio.ALINEACIONES_CAMPBELL) {
        this.graphicList = this.incendio?.ALINEACIONES_CAMPBELL?.GRAFICOS_CAMPBELL || []
      } else {
        if (!this.graphicList) {
          this.graphicList = []
        }
      }

      ArcGIS.drawGraphicsAlineacionesCampbell(JSON.parse(JSON.stringify(this.graphicList)))
    },
    hideAlineacionesCampbell () {
      this.showDialogAlineacionesCampBell = false
      ArcGIS.stopAlineacionesCampbellSketchViewModel()
    },
    onDrawGraphicsEnded (graphics) {
      this.showDialogAlineacionesCampBell = false
      this.editAlineaciones = false
      this.graphicList = graphics

      let date = this.$date.parseDate(this.fecha)

      // console.log('Incendio data: ', this.incendio)
      // console.log('Alineaciones_campbell: ', this.incendio.ALINEACIONES_CAMPBELL)
      let newPlan = {}
      if (this.incendio.ALINEACIONES_CAMPBELL && this.incendio.ALINEACIONES_CAMPBELL.ID_ALINEACIONES_CAMPBELL) {
        newPlan = {
          ID_ALINEACIONES_CAMPBELL: this.incendio.ALINEACIONES_CAMPBELL.ID_ALINEACIONES_CAMPBELL,
          ID_INCENDIO: this.idIncendio,
          GRAFICOS: this.graphicList,
          FECHA: date
        }
        // this.incendio.ALINEACIONES_CAMPBELL.push(newPlan)
      } else {
        newPlan = {
          ID_ALINEACIONES_CAMPBELL: this.$uuid.createUUID(),
          ID_INCENDIO: this.idIncendio,
          GRAFICOS: this.graphicList,
          FECHA: date
        }
      }
      // Convertir datos a modelo BD
      this.modelGraphicsList(newPlan)

      this.$store.dispatch('incendio/editAlineacionesCampbell', newPlan)
    },
    modelGraphicsList (alineaciones) {
    // Convertir datos a modelo BD
      for (let i = 0; i < alineaciones.GRAFICOS.length; i++) {
        let g = alineaciones.GRAFICOS[i]

        if (typeof g.GEOMETRIA === 'string') g.GEOMETRIA = JSON.parse(g.GEOMETRIA)
        if (typeof g.SIMBOLO === 'string') g.SIMBOLO = JSON.parse(g.SIMBOLO)

        // console.log('G: ', g)
        g.ID_ALINEACIONES_CAMPBELL = alineaciones.ID_ALINEACIONES_CAMPBELL

        // FIX Parseo de colores
        if (g.SIMBOLO.color && g.SIMBOLO.color.toRgba) {
          g.SIMBOLO.color = g.SIMBOLO.color.toRgba()
        }
        if (g.SIMBOLO.outline && g.SIMBOLO.outline.color.toRgba) {
          g.SIMBOLO.outline.color = g.SIMBOLO.outline.color.toRgba()
        }
      }

      return alineaciones
    }
  },

  created () {}
}
</script>
<style scoped></style>
